/**
 * The OTP code as typed, carried from `veriplus-mobile-app` `src/auth/otpCode.ts`, D20.
 *
 * Codes are 6 characters from `0-9 A-Z` less `I L O U`, the build note on
 * `OtpEntry.dc.html`. Input is case-insensitive, O folds to 0 and I to 1, and
 * anything else (a space, a hyphen from a pasted email) is dropped rather than
 * refused. `verifyOtpSchema` on the backend folds the same way.
 */
export const OTP_ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

export const OTP_LENGTH = 6;

export function normaliseOtpInput(raw: string): string {
  const folded = raw.toUpperCase().replace(/O/g, '0').replace(/I/g, '1');
  let out = '';
  for (const ch of folded) {
    if (!OTP_ALPHABET.includes(ch)) continue;
    out += ch;
    if (out.length === OTP_LENGTH) break;
  }
  return out;
}
